import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  standalone: false,
  pure: false // This is important! It ensures the list re-sorts when you change an order number.
})
export class OrderByPipe implements PipeTransform {

  transform(array: any[], field: string): any[] {
    if (!Array.isArray(array)) {
      return array;
    }

    // Create a shallow copy to avoid mutating the original array
    const sortedArray = [...array];

    sortedArray.sort((a: any, b: any) => {
      const aValue = a[field] || 0;
      const bValue = b[field] || 0;

      if (aValue < bValue) {
        return -1;
      } else if (aValue > bValue) {
        return 1;
      } else {
        return 0;
      }
    });

    return sortedArray;
  }
}